/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import PropTypes from 'prop-types';
import React from 'react';

function getClassName(child) {
  // this function hides cards in the grid.  it's done here so
  // the hidden cards don't still consume space in the layout
  let className = 'slds-p-horizontal--small slds-size--1-of-1 slds-medium-size--1-of-2 slds-p-bottom--large';

  // Recent Cards are 1-of-2 at larger widths
  if (!child.type.displayName.includes('Recently')) {
    className += ' slds-large-size--1-of-3';
  }

  if (child.props.hide) {
    className += ' slds-hide';
  }
  return className;
}

function CardGrid(props) {
  return (
    <div className="slds-grid slds-wrap slds-grid--pull-padded slds-p-top--large">
      {React.Children.map(props.children, (child) => (
        <div className={getClassName(child)}>{child}</div>
      ))}
    </div>
  );
}

CardGrid.displayName = 'Tile Grid';

CardGrid.propTypes = {
  /**
   * Tiles to be added to the tile grid.
   */
  children: PropTypes.node,
};

export default CardGrid;
